// Letter spacing configuration extracted from Heavitas font
// This ensures perfect spacing matching the original font design

export interface LetterMetrics {
  width: number;
  height: number;
  file: string;
}

export interface SpacingConfig {
  fontName: string;
  letterHeight: number;
  globalSpacing: number;
  kerningPairs: { [key: string]: number };
  letterMetrics: { [key: string]: LetterMetrics };
}

// Letter metrics: width of each character at 800px height
export const letterMetrics: { [key: string]: LetterMetrics } = {
  "0": { width: 703, height: 800, file: "0.png" },
  "1": { width: 423, height: 800, file: "1.png" },
  "2": { width: 589, height: 800, file: "2.png" },
  "3": { width: 567, height: 800, file: "3.png" },
  "4": { width: 651, height: 800, file: "4.png" },
  "5": { width: 594, height: 800, file: "5.png" },
  "6": { width: 604, height: 800, file: "6.png" },
  "7": { width: 594, height: 800, file: "7.png" },
  "8": { width: 590, height: 800, file: "8.png" },
  "9": { width: 611, height: 800, file: "9.png" },
  "A": { width: 865, height: 800, file: "A.png" },
  "B": { width: 649, height: 800, file: "B.png" },
  "C": { width: 796, height: 800, file: "C.png" },
  "D": { width: 724, height: 800, file: "D.png" },
  "E": { width: 605, height: 800, file: "E.png" },
  "F": { width: 608, height: 800, file: "F.png" },
  "G": { width: 807, height: 800, file: "G.png" },
  "H": { width: 709, height: 800, file: "H.png" },
  "I": { width: 222, height: 800, file: "I.png" },
  "J": { width: 576, height: 800, file: "J.png" },
  "K": { width: 735, height: 800, file: "K.png" },
  "L": { width: 605, height: 800, file: "L.png" },
  "M": { width: 893, height: 800, file: "M.png" },
  "N": { width: 753, height: 800, file: "N.png" },
  "O": { width: 801, height: 800, file: "O.png" },
  "P": { width: 660, height: 800, file: "P.png" },
  "Q": { width: 826, height: 800, file: "Q.png" },
  "R": { width: 702, height: 800, file: "R.png" },
  "S": { width: 651, height: 800, file: "S.png" },
  "T": { width: 635, height: 800, file: "T.png" },
  "U": { width: 690, height: 800, file: "U.png" },
  "V": { width: 894, height: 800, file: "V.png" },
  "W": { width: 1213, height: 800, file: "W.png" },
  "X": { width: 843, height: 800, file: "X.png" },
  "Y": { width: 797, height: 800, file: "Y.png" },
  "Z": { width: 667, height: 800, file: "Z.png" },
};

/**
 * Calculate the effective spacing width for a given letter at a given scale
 * This accounts for the actual letter width from the font metrics
 */
export const getLetterWidth = (char: string, scale: number): number => {
  const metrics = letterMetrics[char.toUpperCase()];
  if (!metrics) return 0;
  // Scale the letter width from the 800px base height
  return Math.round((metrics.width / 800) * (scale * 80));
};

/**
 * Calculate proper spacing between letters using actual font metrics
 * This replaces the fixed letterSpacing calculation
 */
export const calculateLetterSpacing = (char: string, scale: number): number => {
  // Use the actual letter width instead of fixed spacing ratio
  return getLetterWidth(char, scale);
};
